import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 bg-zinc-950" data-id="element-7">
      <div className="container mx-auto px-6 md:px-12" data-id="element-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-9">
          {/* Image Side */}
          <div className="relative" data-id="element-10">
            <div className="absolute -inset-4 bg-zinc-900 transform -skew-y-3 z-0" data-id="element-11"></div>
            <img src="https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?q=80&w=2070&auto=format&fit=crop" alt="Professional electrician at work" className="relative z-10 w-full h-[500px] object-cover object-right md:object-center rounded-sm grayscale hover:grayscale-0 transition-all duration-700" data-id="element-12" />
            <div className="absolute -bottom-8 -right-8 bg-red-600 p-8 z-20 hidden md:block" data-id="element-13">
              <p className="text-5xl font-black text-white leading-none mb-2" data-id="element-14">
                15+
              </p>
              <p className="text-white font-bold uppercase tracking-widest text-sm" data-id="element-15">
                Years of
                <br data-id="element-16" />
                Excellence
              </p>
            </div>
          </div>

          {/* Content Side */}
          <div className="relative z-10" data-id="element-17">
            <div className="flex items-center gap-3 mb-4" data-id="element-18">
              <div className="h-[2px] w-8 bg-red-600" data-id="element-19"></div>
              <span className="text-yellow-600 font-bold tracking-widest uppercase text-sm" data-id="element-20">
                Who We Are
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter text-white mb-6 leading-tight" data-id="element-21">
              A Tradition of <br data-id="element-22" />
              <span className="text-zinc-500" data-id="element-23">Quality Craftsmanship.</span>
            </h2>

            <p className="text-zinc-400 text-lg mb-8 leading-relaxed" data-id="element-24">
              Crusader Lighting & Electric is a family-owned and operated
              business serving the greater Des Plaines area. We built our
              reputation on a simple premise: do the job right, treat the
              customer with respect, and stand behind our work.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-25">
              {['Fully Licensed, Bonded, and Insured', 'Upfront, Transparent Pricing', 'Clean, Professional Technicians', 'Strict Adherence to Local & National Codes'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-26">
                  <CheckCircle2 className="w-6 h-6 text-yellow-600 shrink-0 mt-0.5" data-id="element-27" />
                  <span className="text-zinc-300 font-medium" data-id="element-28">{item}</span>
                </li>)}
            </ul>

            <div className="bg-zinc-900 p-6 border-l-4 border-red-600" data-id="element-29">
              <p className="text-white font-medium italic" data-id="element-30">
                "Our goal isn't just to fix your electrical issue today, but to
                be the only electrician you'll ever want to call again."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}